// extracted by mini-css-extract-plugin
module.exports = {"like":"_2VYar","not-clickable":"_2fLoF","notClickable":"_2fLoF","likebutton":"_2WvnE","likes":"fNXJN"};